// extracted by mini-css-extract-plugin
module.exports = {"arrowDown":"Icons_arrowDown__ZNLcU","closeIcon":"Icons_closeIcon__bEkSK"};